import axios from "axios";
import { API_ENDPOINTS } from "../ApiEndPoints";

const productUrl = `${process.env.REACT_APP_API_URL}${API_ENDPOINTS.PRODUCTS}`;
const singleProductUrl = `${process.env.REACT_APP_API_URL}${API_ENDPOINTS.SINGLE_PRODUCT}`;
const featuredProductsUrl = `${process.env.REACT_APP_API_URL}${API_ENDPOINTS.featuredProducts}`;

export const fetchProducts = async (
  language,
  limit,
  page,
  name = "",
  isSearch = false,
  category = "",
  brand = ""
) => {
  try {
    const params = { language };

    if (category) {
      params.category = category;
    }

    if (brand) {
      params.brand = brand;
    }

    if (isSearch) {
      params.name = name;
      params.limit = limit; // Include limit even for search
      params.page = page; // Include page even for search
    } else {
      params.limit = limit;
      params.page = page;
    }

    const response = await axios.get(productUrl, {
      params,
      headers: { "Content-Type": "application/json" },
    });

    return response.data?.product || [];
  } catch (error) {
    console.error("Error fetching products:", error);
    return [];
  }
};

export const fetchSingleProduct = async (product_id, language) => {
  try {
    const response = await axios.get(`${singleProductUrl}/${product_id}`, {
      params: { language },
      headers: { "Content-Type": "application/json" },
    });

    return response.data || null; // Return the product object or null
  } catch (error) {
    console.error("Error fetching single product:", error);
    return null; // Return null instead of throwing an error
  }
};

export const fetchFeaturedproducts = async (language) => {
  try {
    const response = await axios.get(featuredProductsUrl, {
      params: { language },
      headers: { "Content-Type": "application/json" },
    });

    return response.data?.product || null; // Return the product object or null
  } catch (error) {
    console.error("Error fetching single product:", error);
    return null; // Return null instead of throwing an error
  }
};
